<template>
  <div v-if="entry" @click.ctrl="editEntry" :class="{ 'missing-entry': (showMissing && (typeof(entry) !== 'string') && entry.missing), 'busy-entry': ((typeof(entry) !== 'string') && isBusy) }">
    <span v-if="typeof(entry) !== 'string'"><i class="team-identifier" :style="{ backgroundColor: bgColor(entry.team1) }" :title="teamName(entry.team1) + '\n' + teamCoach(entry.team1)">{{ shortTeamId(entry.team1) }}</i> {{ entry.name1 }}</span><br v-if="typeof(entry) !== 'string' && event.type == 'doubles'" />
    <span v-if="typeof(entry) !== 'string' && event.type == 'doubles'"> <i class="team-identifier" :style="{ backgroundColor: bgColor(entry.team2) }" :title="teamName(entry.team2) + '\n' + teamCoach(entry.team2)">{{ shortTeamId(entry.team2) }}</i> {{ entry.name2 }}</span>

    <span v-if="entry == 'bye'" style="opacity: 0.65;"> &nbsp; &nbsp;Bye</span>
    <span v-if="typeof(entry) === 'string' && entry != 'bye'"> &nbsp; &nbsp;{{ entry }}</span>

  </div>
</template>

<script>
export default {
  name: 'Entry',
  props: {
    entry: [ Object, String ],
    event: Object,
    tournament: Object,

    showMissing: {
      type: Boolean,
      default: false
    },

    isBusy: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    editEntry() {

      let page = this.$route.path || '/tournaments';

      if (this.tournament && this.event && this.entry && typeof(entry) !== 'string') {
        this.$router.push('/tournaments/' + this.tournament.id + '/events/' + this.event.id + '/entry/' + this.entry.id + '/edit?next=' + page);
      }
    },

    teamName(teamId) {
      if (this.tournament) {
        let team = this.tournament.teams.filter(team => team.id == teamId);
        if (team && team.length > 0) {
          return team[0].name;
        }
      }

      return 'Unknown team';
    },

    teamCoach(teamId) {
      if (this.tournament) {
        let team = this.tournament.teams.filter(team => team.id == teamId);
        if (team && team.length > 0) {
          return team[0].coach;
        }
      }

      return 'Unknown team';
    },

    shortTeamId(teamId) {
      if (this.tournament) {
        let team = this.tournament.teams.filter(team => team.id == teamId);
        if (team && team.length > 0) {
          return team[0].shortName.charAt(0);
        }
      }

      return 'U';
    },

    bgColor(teamIdentifier) {
      let mod = teamIdentifier % 10;
      return ['#c000c0',
        '#3636df',
        '#459955',
        '#a91b09',
        '#387a73',
        '#63a5c7',
        '#5b783c',
        '#d900b9',
        '#41946b',
        '#4b5796',
        '#9a419a'][mod];
    }
  }
}
</script>

<style scoped>
  i.team-identifier {
    cursor: default;
    font-weight: bold;

    color: #ffffff;
    padding: 2px 6px;
    border-radius: 50%;
    font-size: 15px;

    margin-left: 5px;
    margin-right: 5px;

    opacity: 0.9;
  }

  .missing-entry {
    text-decoration: line-through;
  }

  .busy-entry {
    opacity: 0.4;
  }

</style>
